import React, { createContext } from 'react';
export var baseRenderThumb = function baseRenderThumb(prefixCls) {
  return function () {
    return /*#__PURE__*/React.createElement("div", {
      className: prefixCls + "-slider-thumb"
    });
  };
};
// 因为子组件和 hooks 较多, 为了代码整洁和可读性，做了拆分。
// 参数通过 context 共享
export var SliderContext = /*#__PURE__*/createContext({
  className: '',
  style: {},
  disabled: false,
  useRange: false,
  useAnimation: true,
  size: 2,
  min: 0,
  max: 100,
  step: 1,
  type: 'horizontal',
  showTooltip: 'auto',
  useMarkOnly: false,
  showMarks: false,
  prefixLabel: false,
  suffixLabel: false,
  draggableTrackOnly: false,
  formatTooltip: function formatTooltip(value) {
    return String(value);
  },
  onChange: function onChange() {},
  onAfterChange: function onAfterChange() {},
  renderThumb: baseRenderThumb('')
});
export * from './useSliderIcon';
export * from './useSliderInit';
export * from './useSliderStyle';
export * from './useSliderEvents';